import { createStatusColorObject, createStatusTextObject } from './UtilsFunc';
import i18n from 'src/localization/i18n';
import {
  cilArrowBottom,
  cilArrowThickLeft,
  cilBadge,
  cilCash,
  cilCheck,
  cilCheckCircle,
  cilCircle,
  cilClock,
  cilCode,
  cilFlagAlt,
  cilInfo,
  cilPencil,
  cilReload,
  cilWarning,
  cilX,
} from '@coreui/icons';

const ADMIN_ROLE = ['ADMIN'];
const USER_ROLE = ['USER', 'ADMIN'];
const ANALYZE_ROLE = ['ANALYZE', 'ADMIN'];

const ORDER_STATUS = {
  PENDING: 'PENDING',
  PAID: 'PAID',
  WITHDRAWAL_REQUESTED: 'WITHDRAWAL_REQUESTED',
  WITHDRAWAL_FAILED: 'WITHDRAWAL_FAILED',
  FAILED: 'FAILED',
  DONE: 'DONE',
  EXPIRED: 'EXPIRED',
  REFUNDED: 'REFUNDED',
  REFUND_REQUESTED: 'REFUND_REQUESTED',
  REFUND_FAILED: 'REFUND_FAILED',
};

const ORDER_TEXT = createStatusTextObject(ORDER_STATUS, '');

const ORDER_COLORS = createStatusColorObject(ORDER_STATUS, {
  PENDING: 'warning',
  PAID: 'success',
  WITHDRAWAL_REQUESTED: 'secondary',
  WITHDRAWAL_FAILED: 'danger',
  FAILED: 'danger',
  DONE: 'success',
  EXPIRED: 'danger',
  REFUNDED: 'danger',
  REFUND_REQUESTED: 'secondary',
  REFUND_FAILED: 'secondary',
});

const PIX_STATUS = {
  RECEIVED: 'RECEIVED',
  REFUND_REQUESTED: 'REFUND_REQUESTED',
  REFUND_FAILED: 'REFUND_FAILED',
  REFUNDED: 'REFUNDED',
  PENDING: 'PENDING',
  PAID: 'PAID',
};

const PIX_COLORS = createStatusColorObject(PIX_STATUS, {
  RECEIVED: 'primary',
  REFUND_REQUESTED: 'info',
  REFUND_FAILED: 'danger',
  REFUNDED: 'danger',
  PENDING: 'warning',
  PAID: 'success',
});

const CONTRACT_STATUS = {
  REQUESTED: 'REQUESTED',
  IN_ANALYSIS: 'IN_ANALYSIS',
  RECUSED: 'RECUSED',
  DONE: 'DONE',
};

const CONTRACT_COLORS = createStatusColorObject(CONTRACT_STATUS, {
  REQUESTED: 'info',
  IN_ANALYSIS: 'warning',
  RECUSED: 'danger',
  DONE: 'primary',
});

const VALIDATION_COLORS = {
  ACCEPTED: 'success',
  REJECTED: 'danger',
  PENDING: 'warning',
};

const STATUS = {
  ACTIVE: 'Active',
  INACTIVE: 'Inactive',
  BLOCKED: 'Blocked',
};

const STATUS_COLORS = createStatusColorObject(STATUS, {
  RECEIVED: 'success',
  REFUND_REQUESTED: 'primary',
  REFUND_FAILED: 'danger',
  REFUNDED: 'warning',
});

const WITHDRAWAL_STATUS = {
  REGISTERED: 'REGISTERED',
  SENT: 'SENT',
  PENDING: 'PENDING',
  SUCCESS: 'SUCCESS',
  FAILED: 'FAILED',
};

const WITHDRAWAL_COLORS = createStatusColorObject(WITHDRAWAL_STATUS, {
  REGISTERED: 'warning',
  SENT: 'info',
  PENDING: 'primary',
  SUCCESS: 'success',
  FAILED: 'danger',
});

const EVENT_STATUS = {
  DONE: 'DONE',
  SUCCEEDED: 'SUCCEEDED',
  ACCEPTED: 'SUCCESS',
  FAILED: 'FAILED',
  REJECTED: 'REJECTED',
  UPDATED: 'UPDATED',
  WARNING: 'WARNING',
  INFO: 'INFO',
  NOTE: 'NOTE',
  EXPIRED: 'EXPIRED',
  REFUNDED: 'REFUNDED',
  CREATED: 'CREATED',
  REFUND_FAILED: 'REFUND_FAILED',
  PIX_CASH_IN_RECEIVED: 'PIX_CASH_IN_RECEIVED',
  REFUND_REQUESTED: 'REFUND_REQUESTED',
  WITHDRAWAL_REQUESTED: 'WITHDRAWAL_REQUESTED',
  WITHDRAWAL_REATTEMPT_REQUESTED: 'WITHDRAWAL_REATTEMPT_REQUESTED',
  REATTEMPT_REQUESTED: 'REATTEMPT_REQUESTED',
  MAX_WITHDRAWALS_ATTEMPT: 'MAX_WITHDRAWALS_ATTEMPT',
  LOGIN_SUCCEEDED: 'LOGIN_SUCCEEDED',
  PAYMENT_CONFIRMED: 'PAYMENT_CONFIRMED',
  API_CREDENTIAL_CREATED: 'API_CREDENTIAL_CREATED',
  API_CREDENTIAL_DELETED: 'API_CREDENTIAL_DELETED',
  REGISTER_ORDER_CRYPTO_PURCHASE_FAILED: 'REGISTER_ORDER_CRYPTO_PURCHASE_FAILED',
  UPDATE_ORDER_STATUS_WITHDRAWAL_FAILED: 'UPDATE_ORDER_STATUS_WITHDRAWAL_FAILED',
  HANDLE_CRYPTO_PURCHASE_ERROR: 'HANDLE_CRYPTO_PURCHASE_ERROR',
};

const EVENT_ICONS = {
  DONE: cilBadge,
  DEFAULT: cilCircle,
  ACCEPTED: cilCheck,
  FAILED: cilX,
  UPDATED: cilPencil,
  WARNING: cilWarning,
  LOG: cilCode,
  NOTE: cilInfo,
  EXPIRED: cilClock,
  REFUNDED: cilArrowThickLeft,
  CREATED: cilFlagAlt,
  REFUND_FAILED: cilX,
  PIX_CASH_IN_RECEIVED: cilCash,
  REFUND_REQUESTED: cilX,
  WITHDRAWAL_REQUESTED: cilArrowBottom,
  WITHDRAWAL_REATTEMPT_REQUESTED: cilReload,
  REATTEMPT_REQUESTED: cilReload,
  MAX_WITHDRAWALS_ATTEMPT: cilWarning,
  REJECTED: cilX,
  LOGIN_SUCCEEDED: cilCheckCircle,
  PAYMENT_CONFIRMED: cilCheckCircle,
  API_CREDENTIAL_CREATED: cilCheckCircle,
  API_CREDENTIAL_DELETED: cilCheckCircle,
  REGISTER_ORDER_CRYPTO_PURCHASE_FAILED: cilX,
  UPDATE_ORDER_STATUS_WITHDRAWAL_FAILED: cilX,
  HANDLE_CRYPTO_PURCHASE_ERROR: cilX,
};

const EVENT_COLORS = createStatusColorObject(EVENT_STATUS, {
  DONE: 'success',
  DEFAULT: 'light',
  SUCCEEDED: 'success',
  ACCEPTED: 'success',
  FAILED: 'danger',
  REJECTED: 'danger',
  UPDATED: 'info',
  WARNING: 'warning',
  LOG: 'light',
  NOTE: 'info',
  EXPIRED: 'warning',
  REFUNDED: 'primary',
  CREATED: 'success',
  REFUND_FAILED: 'danger',
  PIX_CASH_IN_RECEIVED: 'success',
  REFUND_REQUESTED: 'danger',
  WITHDRAWAL_REQUESTED: 'info',
  WITHDRAWAL_REATTEMPT_REQUESTED: 'warning',
  REATTEMPT_REQUESTED: 'primary',
  MAX_WITHDRAWALS_ATTEMPT: 'warning',
  LOGIN_SUCCEEDED: 'success',
  PAYMENT_CONFIRMED: 'success',
  API_CREDENTIAL_CREATED: 'success',
  API_CREDENTIAL_DELETED: 'success',
  REGISTER_ORDER_CRYPTO_PURCHASE_FAILED: 'danger',
  UPDATE_ORDER_STATUS_WITHDRAWAL_FAILED: 'danger',
  HANDLE_CRYPTO_PURCHASE_ERROR: 'danger',
});

const OTC_PAYMENT_STATUS = {
  PENDING: 'PENDING',
  PAID: 'PAID',
  FAILED: 'FAILED',
  DONE: 'DONE',
  EXPIRED: 'EXPIRED',
  REFUNDED: 'REFUNDED',
  REFUND_REQUESTED: 'REFUND_REQUESTED',
  REFUND_FAILED: 'REFUND_FAILED',
};

const OTC_PAYMENT_COLORS = createStatusColorObject(OTC_PAYMENT_STATUS, {
  PENDING: 'primary',
  PAID: 'success',
  FAILED: 'danger',
  DONE: 'success',
  EXPIRED: 'warning',
  REFUNDED: 'info',
  REFUND_REQUESTED: 'secondary',
  REFUND_FAILED: 'danger',
});

const OTC_ORDER_TEXT = {
  CREATED: 'CREATED',
  PENDING: 'PENDING',
  PROCESSING: 'PROCESSING',
  FAILED: 'FAILED',
  DONE: 'DONE',
  EXPIRED: 'EXPIRED',
  CANCELLED: 'CANCELLED',
  VALIDATION_ACCEPTED: 'VALIDATION ACCEPTED',
  VALIDATION_REJECTED: 'VALIDATION REJECTED',
  VALIDATION_PENDING: 'VALIDATION PENDING',
};

const OTC_ORDER_STATUS = {
  CREATED: 'CREATED',
  PENDING: 'PENDING',
  PROCESSING: 'PROCESSING',
  FAILED: 'FAILED',
  DONE: 'DONE',
  EXPIRED: 'EXPIRED',
  CANCELLED: 'CANCELLED',
  VALIDATION_ACCEPTED: 'ACCEPTED',
  VALIDATION_REJECTED: 'REJECTED',
  VALIDATION_PENDING: 'PENDING',
};

const OTC_ORDER_COLORS = createStatusColorObject(OTC_ORDER_STATUS, {
  CREATED: 'info',
  PENDING: 'primary',
  FAILED: 'danger',
  CANCELLED: 'danger',
  DONE: 'success',
  EXPIRED: 'warning',
  VALIDATION_ACCEPTED: 'success',
  VALIDATION_REJECTED: 'danger',
  VALIDATION_PENDING: 'info',
});

const translateStatus = (key, fallback) => i18n.t(`statusRegistry.${key}`, fallback ?? key);

export const StatusRegistry = {
  // === ORDER ===
  CREATED: { color: 'info', textKey: 'CREATED', icon: cilFlagAlt },
  PENDING: { color: 'warning', textKey: 'PENDING', icon: cilClock },
  PAID: { color: 'success', textKey: 'PAID', icon: cilCheck },
  WITHDRAWAL_REQUESTED: {
    color: 'secondary',
    textKey: 'WITHDRAWAL_REQUESTED',
    icon: cilArrowBottom,
  },
  WITHDRAWAL_FAILED: { color: 'danger', textKey: 'WITHDRAWAL_FAILED', icon: cilX },
  FAILED: { color: 'danger', textKey: 'FAILED', icon: cilX },
  DONE: { color: 'success', textKey: 'DONE', icon: cilCheckCircle },
  EXPIRED: { color: 'warning', textKey: 'EXPIRED', icon: cilClock },
  REFUNDED: { color: 'info', textKey: 'REFUNDED', icon: cilArrowThickLeft },
  REFUND_REQUESTED: { color: 'secondary', textKey: 'REFUND_REQUESTED', icon: cilX },
  REFUND_FAILED: { color: 'danger', textKey: 'REFUND_FAILED', icon: cilX },
  CANCELLED: { color: 'danger', textKey: 'CANCELLED', icon: cilX },

  // === PIX ===
  RECEIVED: { color: 'success', textKey: 'RECEIVED', icon: cilCash },

  // === CONTRACT ===
  REQUESTED: { color: 'info', textKey: 'REQUESTED', icon: cilFlagAlt },
  IN_ANALYSIS: { color: 'warning', textKey: 'IN_ANALYSIS', icon: cilClock },
  RECUSED: { color: 'danger', textKey: 'RECUSED', icon: cilX },

  // === WITHDRAWAL ===
  REGISTERED: { color: 'warning', textKey: 'REGISTERED', icon: cilFlagAlt },
  SENT: { color: 'info', textKey: 'SENT', icon: cilArrowBottom },
  SUCCESS: { color: 'success', textKey: 'SUCCESS', icon: cilCheck },

  // === VALIDATION ===
  ACCEPTED: { color: 'success', textKey: 'ACCEPTED', icon: cilCheck },
  REJECTED: { color: 'danger', textKey: 'REJECTED', icon: cilX },

  // === STATUS ===
  ACTIVE: { color: 'success', textKey: 'ACTIVE', icon: cilCheckCircle },
  INACTIVE: { color: 'secondary', textKey: 'INACTIVE', icon: cilCircle },
  BLOCKED: { color: 'danger', textKey: 'BLOCKED', icon: cilX },

  // === EVENT ===
  SUCCEEDED: { color: 'success', textKey: 'SUCCEEDED', icon: cilCheck },
  UPDATED: { color: 'info', textKey: 'UPDATED', icon: cilPencil },
  WARNING: { color: 'warning', textKey: 'WARNING', icon: cilWarning },
  INFO: { color: 'info', textKey: 'INFO', icon: cilInfo },
  NOTE: { color: 'info', textKey: 'NOTE', icon: cilInfo },
  PIX_CASH_IN_RECEIVED: { color: 'success', textKey: 'PIX_CASH_IN_RECEIVED', icon: cilCash },
  WITHDRAWAL_REATTEMPT_REQUESTED: {
    color: 'warning',
    textKey: 'WITHDRAWAL_REATTEMPT_REQUESTED',
    icon: cilReload,
  },
  REATTEMPT_REQUESTED: { color: 'primary', textKey: 'REATTEMPT_REQUESTED', icon: cilReload },
  MAX_WITHDRAWALS_ATTEMPT: {
    color: 'warning',
    textKey: 'MAX_WITHDRAWALS_ATTEMPT',
    icon: cilWarning,
  },
  LOGIN_SUCCEEDED: { color: 'success', textKey: 'LOGIN_SUCCEEDED', icon: cilCheckCircle },
  PAYMENT_CONFIRMED: { color: 'success', textKey: 'PAYMENT_CONFIRMED', icon: cilCheckCircle },
  API_CREDENTIAL_CREATED: {
    color: 'success',
    textKey: 'API_CREDENTIAL_CREATED',
    icon: cilCheckCircle,
  },
  API_CREDENTIAL_DELETED: {
    color: 'success',
    textKey: 'API_CREDENTIAL_DELETED',
    icon: cilCheckCircle,
  },
  REGISTER_ORDER_CRYPTO_PURCHASE_FAILED: {
    color: 'danger',
    textKey: 'REGISTER_ORDER_CRYPTO_PURCHASE_FAILED',
    icon: cilX,
  },
  UPDATE_ORDER_STATUS_WITHDRAWAL_FAILED: {
    color: 'danger',
    textKey: 'UPDATE_ORDER_STATUS_WITHDRAWAL_FAILED',
    icon: cilX,
  },
  HANDLE_CRYPTO_PURCHASE_ERROR: {
    color: 'danger',
    textKey: 'HANDLE_CRYPTO_PURCHASE_ERROR',
    icon: cilX,
  },

  PROCESSING: { color: 'info', textKey: 'PROCESSING', icon: cilReload },
  VALIDATION_ACCEPTED: { color: 'success', textKey: 'VALIDATION_ACCEPTED', icon: cilCheck },
  VALIDATION_REJECTED: { color: 'danger', textKey: 'VALIDATION_REJECTED', icon: cilX },
  VALIDATION_PENDING: { color: 'info', textKey: 'VALIDATION_PENDING', icon: cilClock },

  // === DEFAULT fallback ===
  DEFAULT: { color: 'light', textKey: 'DEFAULT', icon: cilCircle },
};

export const getStatusMeta = (status) => {
  const meta = StatusRegistry[status];
  if (!meta) {
    return {
      color: 'light',
      text: translateStatus(status, status),
      icon: cilInfo,
    };
  }

  const { textKey, ...rest } = meta;

  return {
    ...rest,
    text: translateStatus(textKey || status, status),
  };
};

export {
  ADMIN_ROLE,
  USER_ROLE,
  ANALYZE_ROLE,
  ORDER_STATUS,
  ORDER_TEXT,
  ORDER_COLORS,
  PIX_STATUS,
  PIX_COLORS,
  CONTRACT_STATUS,
  CONTRACT_COLORS,
  VALIDATION_COLORS,
  STATUS_COLORS,
  STATUS,
  WITHDRAWAL_STATUS,
  WITHDRAWAL_COLORS,
  EVENT_STATUS,
  EVENT_COLORS,
  EVENT_ICONS,
  OTC_PAYMENT_STATUS,
  OTC_PAYMENT_COLORS,
  OTC_ORDER_TEXT,
  OTC_ORDER_STATUS,
  OTC_ORDER_COLORS,
};
